import { render } from "./CVSInfo.vue?vue&type=template&id=3d352dab&scoped=true"
import script from "./CVSInfo.vue?vue&type=script&lang=js"
export * from "./CVSInfo.vue?vue&type=script&lang=js"

import "./CVSInfo.vue?vue&type=style&index=0&id=3d352dab&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-3d352dab"

export default script